import { IHttpService } from "../../core/service/HttpService";
import User, { IUser } from "../model/User";

export interface IUserService {
  getUsers(): Promise<IUser[]>;
  getAllUserGroups(): Promise<string[]>;
  getUserProfile(): Promise<IUser>;
  updateUser(user: IUser): Promise<any>;
}

const UserService = ({ httpService }): IUserService => {
  const _http: IHttpService = httpService;
  const _baseUrl: string = "/api";
  const _usersPath: string = "users";
  const _groupsPath: string = "groups";

  async function buildUserList(data: any): Promise<IUser[]> {
    return await Promise.all(data.map((item) => User(item)));
  }

  const UserParamsMapper = (user: IUser) => {
    return {
      id: user.id,
      username: user.username,
      languageCode: user.languageCode
    };
  };
  return {
    async getUsers() {
      const path = _http.buildPath(_baseUrl, _usersPath);
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);
      const users = await buildUserList(responseJSON);

      return users;
    },

    async getAllUserGroups() {
      const path = _http.buildPath(_baseUrl, _usersPath, _groupsPath);
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);

      return responseJSON;
    },

    async getUserProfile() {
      const path = _http.buildPath(_baseUrl, _usersPath, "me");
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);
      return User(responseJSON);
    },

    async updateUser(user: IUser) {
      const path = _http.buildPath(_baseUrl, _usersPath, user.id.toString());
      const response = await _http.put(path, {
        params: UserParamsMapper(user)
      });
      return response;
    }
  };
};

export default UserService;
